import type { Author } from '@/types/Author'
import { useQuery } from '@tanstack/vue-query'
import useRelation from '@/composables/useRelation'


export const useAuthorsQuery = (authorContentIds?: number[]) => {
  const { getRelatedContentFields } = useRelation()

  return useQuery<Author[]>({
    queryKey: ['authors', authorContentIds],
    queryFn: () => getRelatedContentFields<Author>(authorContentIds || []),
    enabled: authorContentIds !== undefined,
    staleTime: Infinity,
  })
}
